import React from 'react';
import { ColumnSplittedLayoutStyle } from '../../../styles/components/common/layout';

interface IColumnSplittedLayoutProps {
  children: React.ReactNode;
  sidebar: React.ReactNode;
  hideSidebarOnMobile?: boolean;
}

const ColumnSplittedLayout = (props: IColumnSplittedLayoutProps) => {
  return (
    <>
      <div
        className={`${ColumnSplittedLayoutStyle['column-splitted-layout']} ${
          props.hideSidebarOnMobile
            ? ColumnSplittedLayoutStyle['column-splitted-layout-sidebar-hidden']
            : ''
        }`}>
        <div
          className={
            ColumnSplittedLayoutStyle['column-splitted-layout-sidebar']
          }>
          {props.sidebar}
        </div>
        <div
          className={
            ColumnSplittedLayoutStyle['column-splitted-layout-content-wrapper']
          }>
          {props.children}
        </div>
      </div>
    </>
  );
};

export default ColumnSplittedLayout;
